import { render, staticRenderFns } from "./ContentLayout.vue?vue&type=template&id=4f4842fa&scoped=true"
import script from "./ContentLayout.vue?vue&type=script&lang=ts"
export * from "./ContentLayout.vue?vue&type=script&lang=ts"
import style0 from "./ContentLayout.vue?vue&type=style&index=0&id=4f4842fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4842fa",
  null
  
)

export default component.exports